<template>
  <div>
    <div class="date-row d-flex">
      <div class="dom d-flex justify-content-center">
        <span
          class="align-self-center"
          v-text="dayDate.format(formatDateDay)"
        ></span>
      </div>
      <div class="weekday d-flex justify-content-center">
        <span
          class="align-self-center"
          v-text="dayDate.format(formatDateWeekday)"
        ></span>
      </div>
    </div>
    <div class="events">
      <event-card
        v-for="event in events"
        :key="event.id"
        :eventName="getEventName(event)"
        :eventStartDate="event.startDate"
        :eventEndDate="event.endDate"
        :eventPostalCode="event.postalCode"
        :eventCity="event.city"
        :eventCrops="event.crops"
        :href="getLinkToEventDetailView(event.id)"
      ></event-card>
    </div>
  </div>
</template>

<script>
import EventMixin from '../mixins/EventMixin';
import EventCard from './event-card.vue';

export default {
  name: 'EventDay',
  components: {
    EventCard,
  },
  props: {
    dayDate: {
      type: Object,
      required: true,
    },
    events: {
      type: Array,
      required: true,
    },
  },
  inject: ['formatDateDay', 'formatDateWeekday', 'detailView'],
  mixins: [EventMixin],
};
</script>

<style lang="scss">
  .event-day {
    padding-top: 20px;
    .date-row {
      margin-bottom: 10px;
      .dom {
        font-size: 24px;
        height: 40px;
        width: 40px;
        background-color: #d7d9db;
      }
      .weekday {
        margin-left: 20px;
        font-size: 16px;
      }
    }
    .events {
      margin-left: 60px;
    }
  }
</style>
